export const adminBatchSelectionCommon = {
  partialSelected: "已选择前 {selected} 条（当前筛选共 {total} 条，超出部分未选中）",
  allSelected: "已选择 {count} 条",
};

export const adminBatchCommon = {
  publishDrafts: "批量发布（仅草稿）",
  archive: "批量归档",
  deleteDrafts: "批量删除（仅草稿）",
  confirmDeleteDraftsDescription: "删除后无法恢复。",
  archiveAction: "归档",
};

export function buildAdminConfirmBatchCommon(entity: string) {
  return {
    publishDraftsTitle: `确认发布选中的 {count} 份草稿${entity}？`,
    archiveTitle: `确认归档选中的 {count} 份${entity}？`,
    deleteDraftsTitle: `确认删除选中的 {count} 份草稿${entity}？`,
    deleteDraftsDescription: "删除后无法恢复。",
  };
}

export const adminArchivedToggleCommon = {
  showArchived: "显示已归档",
  hideArchived: "隐藏已归档",
  summaryArchivedVisible: "归档可见：{value}",
};

export function buildAdminSummaryTotal(entity: string) {
  return `${entity}总数：{count}`;
}

export function buildAdminBatchSelectionMessages(entity: string) {
  return {
    selectDraftsToPublish: `仅草稿${entity}可发布，请重新选择`,
    selectArchivableToArchive: `当前未选中可归档${entity}`,
    selectDraftsToDelete: `仅草稿${entity}可删除，请重新选择`,
  };
}

export function buildAdminBatchResultMessages(entity: string, unit: string) {
  return {
    batchPublished: `已发布 {count} ${unit}${entity}`,
    batchArchived: `已归档 {count} ${unit}${entity}`,
    batchDeleted: `已删除 {count} ${unit}草稿${entity}`,
  };
}
